
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class WeedsClassPallete extends Vue {
  @Prop()
  color: string;
}
